import { ApiClientError } from '@packlink/packlink-sdk';

export function onReadOnlyQueryRetry(failureCount: number, error: ApiClientError): boolean {
    const status = error?.status ?? 0;
    return failureCount < 4 && status >= 500;
}
